import {Input} from '@angular/core';
import {FileData} from '../../../../../core/file/file-data';

export abstract class AbstractPreviewFileTypeComponent {
  @Input() fileData: FileData = null;
}
